import { TourStep } from 'types/tour';

import { APPLICATIONS, JOBS } from 'constants/path';

interface FilterTourStepsParams {
  steps: TourStep[];
  applicationId: string | null;
  jobId: string | null;
}

export const filterTourSteps = ({
  steps,
  applicationId,
  jobId
}: FilterTourStepsParams): TourStep[] => {
  let filteredSteps = steps;

  if (!applicationId) {
    filteredSteps = filteredSteps.filter(
      (step) => !step.page.startsWith(APPLICATIONS)
    );
  }

  if (!jobId) {
    filteredSteps = filteredSteps.filter((step) => !step.page.startsWith(JOBS));
  }

  return filteredSteps;
};
